export default "__VITE_ASSET__C82BRh4N__"